import React, { useState, useEffect, useCallback } from "react"
import DashboardHeader from "./DashboardHeader"
import KPIRow from "./KPIRow"
import NeedsAttentionPanel from "./NeedsAttentionPanel"
import LearningActivityChart from "./LearningActivityChart"
import EnrollmentCompletionSection from "./EnrollmentCompletionSection"
import LearnerHealthSection from "./LearnerHealthSection"
import QuickActionsCTA from "./QuickActionsCTA"
import LearningFunnelSection from "./LearningFunnelSection"
import ProductPerformanceSection from "./ProductPerformanceSection"
import ProductConversionSection from "./ProductConversionSection"
import ProgramPerformanceSection from "./ProgramPerformanceSection"
import CohortPerformanceSection from "./CohortPerformanceSection"
import AssessmentPerformanceSection from "./AssessmentPerformanceSection"
import CredentialOverviewSection from "./CredentialOverviewSection"
import ProofOfLearningSection from "./ProofOfLearningSection"
import EngagementOverviewSection from "./EngagementOverviewSection"
import RecentActivitySection from "./RecentActivitySection"
import EngagementHeatmapSection from "./EngagementHeatmapSection"
import OnChainCredentialsSection from "./OnChainCredentialsSection"
import RevenueOverviewSection from "./RevenueOverviewSection"
import CustomerOverviewSection from "./CustomerOverviewSection"
import RecentOrdersSection from "./RecentOrdersSection"
import { computeDashboardKPIs } from "../../../utils/dashboardAnalyticsHelpers"
import { getDashboardPreference, updateDashboardDateRange } from "../../../utils/orgHelpers"

// Section 1 (header) + Section 2 (KPI row) for now. Later sections (Needs Your
// Attention, Learning Activity, Funnel, etc.) get added here one at a time.
const DashboardOverview = ({ organization, onNavigateTab }) => {
  const orgId = organization?.orgId
  const [dateRange, setDateRange] = useState("30d")
  const [kpis, setKpis] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    getDashboardPreference(orgId).then(({ dateRange: saved }) => setDateRange(saved))
  }, [orgId])

  const loadKPIs = useCallback(async () => {
    if (!orgId) return
    setLoading(true)
    const data = await computeDashboardKPIs(orgId, dateRange)
    setKpis(data)
    setLoading(false)
  }, [orgId, dateRange])

  useEffect(() => {
    loadKPIs()
  }, [loadKPIs])

  const handleDateRangeChange = async (rangeKey) => {
    setDateRange(rangeKey)
    if (orgId) updateDashboardDateRange(orgId, rangeKey).catch(() => {})
  }

  return (
    <div>
      <DashboardHeader
        organization={organization}
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
        onExport={() => {}}
        onCustomize={() => {}}
      />
      {loading ? (
                <div className="flex gap-4 overflow-x-hidden mb-6 px-1">
          {Array.from({ length: 4 })?.map((_, i) => (
            <div key={i} className="flex-none w-[68%] sm:w-[45%] lg:w-1/4 h-24 rounded-lg bg-muted animate-pulse" />
          ))}
        </div>
            ) : (
        <>
                                        <KPIRow kpis={kpis} onNavigate={onNavigateTab} />
          <div className="flex flex-col lg:flex-row gap-4 mb-6 items-stretch">
            <div className="flex-1 min-w-0">
              <NeedsAttentionPanel orgId={orgId} onNavigate={onNavigateTab} />
            </div>
            <div className="lg:w-72 shrink-0">
                            <QuickActionsCTA
                text="Manage Team"
                buttonText="See All"
                onButtonClick={() => onNavigateTab?.("team")}
              />
            </div>
          </div>
                                        <LearningActivityChart orgId={orgId} />
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
                        <EnrollmentCompletionSection orgId={orgId} />
            <LearnerHealthSection orgId={orgId} onNavigate={onNavigateTab} />
          </div>
                    <LearningFunnelSection orgId={orgId} />
                    <ProductPerformanceSection orgId={orgId} onNavigateTab={onNavigateTab} />
                    <ProductConversionSection orgId={orgId} />
                    <ProgramPerformanceSection orgId={orgId} onNavigateTab={onNavigateTab} />
                    <CohortPerformanceSection orgId={orgId} />
                    <AssessmentPerformanceSection orgId={orgId} />
                    <CredentialOverviewSection orgId={orgId} />
                    <ProofOfLearningSection orgId={orgId} />
                    <div className="mb-6">
            <OnChainCredentialsSection
              organization={organization}
              onNavigateTab={onNavigateTab}
              variant="compact"
            />
          </div>
            <RevenueOverviewSection orgId={orgId} dateRange={dateRange} onNavigateTab={onNavigateTab} />
            <CustomerOverviewSection orgId={orgId} dateRange={dateRange} onNavigateTab={onNavigateTab} />
          <RecentOrdersSection orgId={orgId} onNavigateTab={onNavigateTab} />
                            <EngagementOverviewSection orgId={orgId} onNavigateTab={onNavigateTab} />
                                        <QuickActionsCTA
                      text="See when your learners are most active, day by day and hour by hour."
                      buttonText="See Engagement Heatmap"
                      onButtonClick={() => onNavigateTab?.("engagement-activity")}
                    />
                                                            <div className="lg:max-w-md mb-6">
                      <RecentActivitySection orgId={orgId} />
                    </div>
        </>
      )}
    </div>
  )
}

export default DashboardOverview